import { getAllstarURI, ALLSTAR_AUTH_HEADERS } from "@ugg/shared/api/requests/allstar/allstar-helpers";
import { normalizeRiotId } from "@ugg/shared/utils/riot-id-helpers";
import { useCallback, useEffect, useState } from "react";
import { useAsyncFetch } from "@ugitgud/legos/hooks/useAsyncFetch";

export interface ClipsPlaylistData {
  message: string;
  requestId: string;
  data: {
    count: number;
    currentPage: number;
    limit: number;
    playlistUrl: string;
    fallback: boolean;
  };
}

export function useGetUserPlaylistClips(riotId: string, region: string, options: { skip?: boolean } = {}) {
  const { skip = false } = options;
  const searchParams = new URLSearchParams({
    riotID: normalizeRiotId(riotId),
    region: region,
    sort: "score",
    limit: "30",
  });
  const url = `${getAllstarURI()}/league/clips/playlist?${searchParams.toString()}`;
  const { data, loading, error } = useAsyncFetch<ClipsPlaylistData | null>(url, ALLSTAR_AUTH_HEADERS, "GET");

  return { data, loading, error };
}
